import { getMessageSummaryText } from '@helpers/message-summary';
import renderText from '@helpers/render-text';
import type { ApiMessage } from '@interfaces/message';
import buildClassName from '@utils/build-class-name';
import { formatPastTimeShort } from '@utils/date-format';
import type { FC } from 'react';

import styles from './MiddleSearchResult.module.scss';

interface OwnProps {
  message: ApiMessage;
  query?: string;
}

const TRUNCATE_LENGTH = 200;

const MiddleSearchResult: FC<OwnProps> = ({ message, query }) => {
  const summaryText = getMessageSummaryText(message, TRUNCATE_LENGTH);

  return (
    <div className={buildClassName(styles.root)}>
      <div className={styles.info}>
        <div className={styles.topRow}>
          <div className={styles.title}>
            <h3 dir="auto" className={styles.fullName}>
              {message.author_name}
            </h3>
          </div>
          <div className={buildClassName(styles.meta, styles.lastMessageMeta)}>
            <span className={styles.time}>{formatPastTimeShort(message.created_at)}</span>
          </div>
        </div>
        <div className={styles.subtitle}>
          <span>{query ? renderText(summaryText, query) : renderText(summaryText)}</span>
        </div>
      </div>
    </div>
  );
};

export default MiddleSearchResult;
